export default "__VITE_ASSET__ChFEQsbc__"